import useGetLogoImage from '@/hooks/useGetLogoImage';

interface Props {
    children?: any;
    avatarId: string;
}

const GetLogoImageContainer = ({ children, avatarId }: Props) => {
    const { mediaData, isLoading } = useGetLogoImage({
        avatarId,
    });

    return children({
        logoUrl: mediaData?.downloadUrl ?? undefined,
        loadingLogo: isLoading,
    });
};

export default GetLogoImageContainer;
